import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from './login/login.component';

import { AddActivityFormatComponent } from './activity/add-format/add-format.component';
import { AddChoirPerformanceComponent } from './choir/add-performance/add-performance.component';
import { AddITPerformanceComponent } from './it/add-performance/add-performance.component';
import { AddLeagueComponent } from './add-league/add-league.component';
import { AddMediaPerformanceComponent } from './media/add-performance/add-performance.component';
import { AddMemberComponent } from './add-member/add-member.component';
import { AddTeamComponent } from './add-team/add-team.component';
import { AddTheatrePerformanceComponent } from './theatre/add-performance/add-performance.component';
import { AddUserComponent } from './add-user/add-user.component';

import { EditChoirPerformanceComponent } from './choir/edit-performance/edit-performance.component';
import { EditITPerformanceComponent } from './it/edit-performance/edit-performance.component';
import { EditLeagueComponent } from './edit-league/edit-league.component';
import { EditMediaPerformanceComponent } from './media/edit-performance/edit-performance.component';
import { EditMemberComponent } from './edit-member/edit-member.component';
import { EditTeamComponent } from './edit-team/edit-team.component';
import { EditTheatrePerformanceComponent } from './theatre/edit-performance/edit-performance.component';
import { EditUserComponent } from './edit-user/edit-user.component';

import { ActivityFormatListComponent } from './activity/format-list/format-list.component';
import { ChoirPerformanceListComponent } from './choir/performance-list/performance-list.component';
import { ChurchListComponent } from './church-list/church-list.component';
import { ITPerformanceListComponent } from './it/performance-list/performance-list.component';
import { LeagueListComponent } from './league-list/league-list.component';
import { MediaPerformanceListComponent } from './media/performance-list/performance-list.component';
import { MemberListComponent } from './member-list/member-list.component';
import { TeamListComponent } from './team-list/team-list.component';
import { TheatrePerformanceListComponent } from './theatre/performance-list/performance-list.component';
import { UserListComponent } from './user-list/user-list.component';
import { ReportListComponent } from './reports/report-list/report-list.component';
import { ReportViewerComponent } from './reports/report-viewer/report-viewer.component';
import { ResearchPerformanceListComponent } from './research/performance-list/performance-list.component';
import { EditResearchPerformanceComponent } from './research/edit-performance/edit-performance.component';
import { AddResearchPerformanceComponent } from './research/add-performance/add-performance.component';

import { ImportMembersComponent } from './import-members/import-members.component';

import { MigrateActivityFormatsComponent } from './migrate-activity-formats/migrate-activity-formats.component';
import { MigrateUsersComponent } from './migrate-users/migrate-users.component';
import { MigrateSportLeaguesComponent } from './migrate-sport-leagues/migrate-sport-leagues.component';
import { VisualArtPerformanceListComponent } from './visualArt/performance-list/performance-list.component';
import { EditVisualArtPerformanceComponent } from './visualArt/edit-performance/edit-performance.component';
import { AddVisualArtPerformanceComponent } from './visualArt/add-performance/add-performance.component';
import { NoAccessComponent } from './no-access/no-access.component';

var appRoutes: Routes = [
  // TODO: Add Deahboard
  { path: '', component: LoginComponent },

  { path: 'activity/formatList', component: ActivityFormatListComponent, children: [
    { path: 'add', component: AddActivityFormatComponent },
  ] },

  { path: 'churchList', component: ChurchListComponent },

  { path: 'choir/performanceList', component: ChoirPerformanceListComponent, children: [
    { path: 'add', component: AddChoirPerformanceComponent },
    { path: ':id/edit', component: EditChoirPerformanceComponent }
  ] },

  { path: 'it/performanceList', component: ITPerformanceListComponent, children: [
    { path: 'add', component: AddITPerformanceComponent },
    { path: ':id/edit', component: EditITPerformanceComponent }
  ] },

  { path: 'media/performanceList', component: MediaPerformanceListComponent, children: [
    { path: 'add', component: AddMediaPerformanceComponent },
    { path: ':id/edit', component: EditMediaPerformanceComponent }
  ] },

  { path: 'research/performanceList', component: ResearchPerformanceListComponent, children: [
    { path: 'add', component: AddResearchPerformanceComponent },
    { path: ':id/edit', component: EditResearchPerformanceComponent }
  ] },

  { path: 'theatre/performanceList', component: TheatrePerformanceListComponent, children: [
    { path: 'add', component: AddTheatrePerformanceComponent },
    { path: ':id/edit', component: EditTheatrePerformanceComponent }
  ] },

  { path: 'visualArt/performanceList', component: VisualArtPerformanceListComponent, children: [
    { path: 'add', component: AddVisualArtPerformanceComponent },
    { path: ':id/edit', component: EditVisualArtPerformanceComponent }
  ] },

  { path: 'leagueList', component: LeagueListComponent, children: [
    { path: 'add', component: AddLeagueComponent },
    { path: ':id/edit', component: EditLeagueComponent }
  ] },

  { path: 'memberList', component: MemberListComponent, children: [
    { path: 'add', component: AddMemberComponent },
    { path: ':id/edit', component: EditMemberComponent }
  ] },

  { path: 'reportList', component: ReportListComponent, children: [
    { path: 'view', component: ReportViewerComponent }
  ] },

  { path: 'report/view/:reportid/:page', component: ReportViewerComponent },

  { path: 'teamList',   component: TeamListComponent, children: [
    { path: 'add', component: AddTeamComponent },
    { path: ':id/edit', component: EditTeamComponent }
  ] },

  { path: 'userList',   component: UserListComponent, children: [
    { path: 'add', component: AddUserComponent },
    { path: ':id/edit', component: EditUserComponent }
  ] },

  { path: 'import/members', component: ImportMembersComponent },
  { path: 'migrate/users', component: MigrateUsersComponent },
  { path: 'migrate/activityFormats', component: MigrateActivityFormatsComponent },
  { path: 'migrate/sportLeagues', component: MigrateSportLeaguesComponent },

  { path: 'no-access', component: NoAccessComponent }
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes)
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
